import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchMe } from "./auth";

/**
 * Route guard for broker-only pages (e.g. /check, prospecting tools).
 *
 * - Not authenticated → redirect to /login (preserves `from`)
 * - Authenticated but not a broker (seller/buyer) → redirect to /projects
 *   where they'll see their own workspace list. Avoids dead-ending
 *   sellers/buyers if they paste a broker URL.
 *
 * Reads `me.global_nav.is_broker` from the backend so the source of
 * truth stays server-side (same flag the nav drawer uses).
 */
export default function RequireBroker({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading | broker | not-broker | unauth

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const me = await fetchMe();
        if (!alive) return;
        if (!me) { setStatus("unauth"); return; }
        const isBroker = !!(me?.global_nav?.is_broker);
        setStatus(isBroker ? "broker" : "not-broker");
      } catch {
        if (alive) setStatus("unauth");
      }
    })();
    return () => { alive = false; };
  }, []);

  if (status === "loading") return null;
  if (status === "unauth") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (status === "not-broker") {
    return <Navigate to="/projects" replace />;
  }
  return children;
}
